import { Layers } from "lucide-react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@monorepo-apps/ui/src/components/select";

import {
  useDefaultWeightsPreset,
  useSetDefaultWeightsPreset,
  useWeightsPresets,
} from "@/application/use-cases/products/use-weights.queries";

/**
 * Compact switcher for the active weights preset (the global lens). Self-
 * contained — drop it on any page that wants to re-rank under a different
 * weighting. Switching writes the default preset, so products AND candidate
 * composites recompute everywhere at once. Renders nothing until presets load.
 */
export function ActivePresetSelector({ label = "Weights lens" }: { label?: string }) {
  const presetsQ = useWeightsPresets();
  const activeQ = useDefaultWeightsPreset();
  const setDefault = useSetDefaultWeightsPreset();

  const presets = presetsQ.data ?? [];
  const active = activeQ.data ?? null;

  if (presets.length === 0) return null;

  return (
    <div className="flex items-center gap-2">
      <span className="text-muted-foreground inline-flex items-center gap-1.5 text-[10.5px] font-medium tracking-[0.12em] uppercase">
        <Layers className="size-3" />
        {label}
      </span>
      <Select
        value={active?.id ?? ""}
        onValueChange={(id) => {
          if (id && id !== active?.id) setDefault.mutate(id);
        }}
      >
        <SelectTrigger className="h-8 w-52 text-[12.5px]">
          <SelectValue placeholder="Select preset" />
        </SelectTrigger>
        <SelectContent>
          {presets.map((p) => (
            <SelectItem key={p.id} value={p.id}>
              {p.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
